import { COMMON_MIXPANEL_PAGE } from '../../common/constants/mixpanelConstants'
import { UTM_CAMPAIGN } from '../../common/constants/utm'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const parentalLeaveCoachingMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.PARENTAL_LEAVE_COACHING,
  iFrameSrcUrl: '/parental-leave-coaching',
  micrositeUrl: 'parental-leave-coaching',
  title: {
    id: 'parentalLeaveCoaching.title',
    defaultMessage: 'Support with parental leave',
    description: 'Microsite page title',
  },
  customerPropertyConditions: [],
  featureFlag: 'isParentalLeaveCoachingEnabled',
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_PROVIDER_BOOKING },
    { key: CMS_MICROSITE_MESSAGE_KEY.OPEN_EXTERNAL_LINK },
    { key: CMS_MICROSITE_MESSAGE_KEY.OPEN_CONTACT_CARE_NAVIGATOR_MODAL },
  ],
  page: COMMON_MIXPANEL_PAGE.PARENTAL_LEAVE_COACHING,
  trackUTMParams: {
    utm_campaign: UTM_CAMPAIGN.PARENTAL_LEAVE_COACHING,
  },
  shouldSupportSpanish: true,
  shouldHideForInternational: false,
  usePageForViewEvent: true,
}
